<div class="accordion-item">
    <h2 class="accordion-header" id="headingConserverende">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseConserverende" aria-expanded="false" aria-controls="collapseConserverende">
            Conserverende aanslag
        </button>
    </h2>
    <div id="collapseConserverende" class="accordion-collapse collapse" aria-labelledby="headingConserverende"
         data-bs-parent="#accordionExample">
        <div class="accordion-body">
            Een conserverende aanslag wordt opgelegd om toekomstige belastingclaims veilig te stellen, vaak in
            internationale situaties (zoals emigratie).
            <div class="space20"></div>
            In het kader van schenkbelasting kan een conserverende aanslag
            voorkomen bij schenkingen van aanmerkelijk belang aandelen door een Nederlandse inwoner aan een buitenlandse
            begiftigde. De aanslag wordt opgelegd maar de invordering kan worden uitgesteld onder voorwaarden. Deze
            aanslagen vereisen een zorgvuldige beoordeling van verdragsbepalingen en internationale woonplaatskwesties.
        </div>
    </div>
</div>
